export const blogsArr = [
  {
    id: 1,
    title: "Spice Girls",
    img: "https://imissthe90s.files.wordpress.com/2010/04/spice-girls.jpg?w=500&h=375",
    author: "imissthe90s",
    date: "April 22, 2010",
    body: "Simply the greatest thing to come out of the 90s, the Spice Girls dominated the entertainment industry during the second half of the decade and became the biggest thing on the planet overnight.",
  },
  {
    id: 2,
    title: "Sega Mega Drive",
    img: "https://imissthe90s.files.wordpress.com/2010/04/sega1.jpg",
    author: "imissthe90s",
    date: "April 15, 2010",
    body: "The Sega Mega Drive is to games consoles in the 90s as George Best was to football 30 year previously. Video gaming and football were obviously around before them but once they appeared on the scene the future would change forever.",
  },
  {
    id: 3,
    title: "Virgin Cola",
    img: "https://imissthe90s.files.wordpress.com/2010/04/virgin-cola.png?w=500&h=384",
    author: "imissthe90s",
    date: "April 6, 2010",
    body: "Fair play to Richard Branson, he gets most things right. The madcap entrepreneur owns the world famous Virgin brand and runs successful airlines, train networks, music festivals and even now his own Formula One racing team. But Virgin Cola was a mistake.",
  },
  {
    id: 4,
    title: "Yo-yos",
    img: "https://imissthe90s.files.wordpress.com/2010/03/yoyo.jpg?w=500&h=339",
    author: "imissthe90s",
    date: "March 22, 2010",
    body: "They say everything comes back around and in the late 90s the yoyo did return to the playgrounds of Britain, but unlike when my mum and dad’s generation were fascinated by them going up and down a piece of string, we took it to the next level.",
  },
];
